import type { IPersonListItem } from '../../../api/generated/person-controller/person-controller';
import type { PersonDataFormValues } from '../components/PersonDataFormFields';

export function getCreatedPersonId(response: string | { personId: string }) {
  return typeof response === 'string' ? response : response.personId;
}

export function getPersonMatchCheckPayload(data: PersonDataFormValues) {
  return {
    firstName: data.firstName.trim(),
    lastName: data.lastName.trim(),
    birthDate: data.birthDate,
  };
}

export function mapCreatedPersonToListItem(data: PersonDataFormValues, personId: string): IPersonListItem {
  return {
    id: personId,
    firstName: data.firstName.trim(),
    lastName: data.lastName.trim(),
    birthDate: data.birthDate,
    gender: data.gender,
    created: null,
    phone: data.mobilePhoneNumber.trim() || data.privatePhoneNumber.trim() || data.workPhoneNumber.trim() || null,
    email: data.email.trim() || null,
  };
}

export function getDefaultCreatePersonValues(): PersonDataFormValues {
  return {
    firstName: '',
    lastName: '',
    birthDate: '',
    gender: null,
    mobilePhoneNumber: '',
    privatePhoneNumber: '',
    workPhoneNumber: '',
    email: '',
    nationality: null,
    origin: null,
    arrival: '',
    asylumNumber: '',
    zemisNumber: '',
    languages: [],
    street: '',
    additionalInformation: '',
    bezugspersonen: [],
    residencyPermit: null,
    zip: '',
    city: '',
    canton: '',
    address: null,
    contact: null,
    salutation: '',
    livingStatus: null,
    note: '',
  };
}
